import { Box } from '@mui/material';
import React, { useState } from 'react';
import ActionHeader from '../../../ActionHeader/ActionHeader';
import FormView from '../../../../common/Form/FormView';
import { FormServices } from '../../../../../../services/formConfig';
import { showToast } from '../../../../../../utils/common.util';
import {
  stringSubstitute,
  ToastMessages,
} from '../../../constants/onboarding.constants';
import { toastMessage, ToastThemes } from '../../../../../../constants/common';
import ModalDialog from '../../../../../../atoms/Modal/ModalDialog';

const PaycycleFormView = (props) => {
  const { setViewMode, formConfig, formData, setShowForm, isEditable } = props;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteDraftclaim = async () => {
    setDeleteModalOpen(false);
    const service = new FormServices();
    await service
      .deleteOrgConfigDetail(formData?.id)
      .then(async () => {
        showToast(
          ToastMessages.success.replace(stringSubstitute, toastMessage.delete),
          ToastThemes.success
        );
        setShowForm(false);
      })
      .catch((err) => {
        showToast(
          ToastMessages.failed.replace(stringSubstitute, toastMessage.delete),
          ToastThemes.error
        );
      });
  };

  return (
    <Box>
      <Box sx={{ flexGrow: 1 }}>
        <Box mb={3} mx={-3} mt={-3}>
          <ActionHeader
            labelText={formData?.var_name || 'New Config'}
            editButtonText="Edit"
            onEditClick={() => setViewMode(false)}
            showSave={isEditable ?? false}
            showBackButton
            onBackClick={() => setShowForm(false)}
          />
        </Box>
        <FormView list={formConfig} info={formData} />
      </Box>
      <ModalDialog
        showModal={deleteModalOpen}
        onClickConfirm={handleDeleteDraftclaim}
        onClickClose={() => setDeleteModalOpen(false)}
        description={'Are you sure want to delete the config?'}
        title={'Delete Config'}
        primaryAction={'Delete'}
        secondaryAction={'Cancel'}
      />
    </Box>
  );
};

export default PaycycleFormView;
